/// <reference path="../../../AppKitchen/typings/AppKitchen.UI.d.ts"/>
/// <reference path="../../typings/EEX.McEc.Api.d.ts"/>

module EEX.McEc.Data.Provider {

    export class CertificateFileProvider extends AppKitchen.Data.Provider.ProviderBase {

        public load(request: McEc.Domain.CertificateFileRequest): JQueryPromise<string> {
            return this.do("CertificateFile", request);
        }
    }
}